import React from 'react';

export default function BrandMark() {
  return <span className="brand-mark" aria-hidden="true">
    <img className="brand-mark-light" src={`${process.env.PUBLIC_URL}/brand/mark-light.svg?v=compass-2`}
      width="40" height="40" alt="" />
    <img className="brand-mark-dark" src={`${process.env.PUBLIC_URL}/brand/mark.svg?v=compass-2`}
      width="40" height="40" alt="" />
  </span>;
}

export function BrandSplash() {
  return <div className="app-splash" role="status">
    <BrandMark />
    <strong className="splash-title">Agent R&amp;D</strong>
    <span>Загрузка...</span>
  </div>;
}
